import './Vendor/slick/slick';

import { Foundation } from 'foundation-sites/js/foundation.core';
Foundation.addToJquery($);

import './components/responsive-background-image';
import './components/job-application-form';
import './components/case-overview';
import './components/gallery-slider';
import './components/auto-scroll';
import './components/animation';
import './components/contact-popup';
import './components/last-visited-node';

(function ($) {
    const $html = $('html'),
        $body = $('body');

    $(document).foundation();

    // Document ready
    // --------------
    $(function () {

        // Language switch
        // -----------------------------------
        $('.current-language').bind('click', function () {
            $('.language-switch').toggleClass('active');
        });

        // Navigation switch
        // -----------------------------------

        // const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        let navigationOpen = false;
        $('.toggle-nav').bind('click', function () {
            navigationOpen = !navigationOpen;
            $('#header, #header .toggle-nav').add($html).toggleClass('nav-open', navigationOpen);
            $('.language-switch').removeClass('active');
            $('.primary-menu').toggleClass('nav-open', navigationOpen).removeClass('nav-hidden');

            if (!$('.primary-menu').hasClass('nav-open')) {
                $('.primary-menu').add($html).addClass('nav-closed');
                $('#header, #header .toggle-nav').add($html).addClass('nav-closed');
            } else {
                $('.primary-menu').add($html).removeClass('nav-closed');
                $('#header, #header .toggle-nav').add($html).removeClass('nav-closed');
            }
        });

        $( '.menu-backdrop' ).bind('click', function () {
            navigationOpen = !navigationOpen;
            $(this).parent().toggleClass('nav-open').addClass('nav-closed');
            $('html, #header, #header .toggle-nav').removeClass('nav-open');
        });


        // Add 'not-empty' class if input field has value
        //-----------------------------------
        $('textarea, input').each(function () {
            function toggleNotEmpty() {
                $(this).closest('.form-group')
                    .toggleClass('not-empty', $(this).val() !== '');
            }
            $(this)
                .each(toggleNotEmpty)
                .blur(toggleNotEmpty)
                .focus(function() {
                    $(this).closest('.form-group').addClass('not-empty');
                });
        });


        // Close navigation when pressing escape
        // -----------------------------------
        $(document).keyup(function (evt) {
            if (evt.keyCode === 27) {
                $('#header', $html).removeClass('nav-open');
                $('.primary-menu').removeClass('active');
            }
        });


        // Header hide/show when scrolling
        // -----------------------------------
        const langSwitch = $('.language-switch');
        let lastScrollTop = 0;

        $(window).bind('scroll', function () {
            let st = $(this).scrollTop();

            // Extra check for mobile - lastscroll only positive values
            if (st > lastScrollTop && lastScrollTop >= 0) {
                if (!$html.hasClass('menu-active')) {
                    if (!$html.hasClass('menu-active') && st > 100 ) {
                        langSwitch.removeClass('active');
                    }
                }
            }

            lastScrollTop = st;
        });


        // Featured blog margin
        // -----------------------------------
        function featuredBlogTitlePosition() {
            const articleSection = $('article.card-article:nth-child(1)').find('section'),
                height = articleSection.outerHeight();
            articleSection.css('margin-top', - height / 2 + 'px');
        }
        featuredBlogTitlePosition();

        $(window).on('resize', function () {
            featuredBlogTitlePosition();
        });

        // Service cards hover classes
        // -----------------------------------
        $('.service-card').hover(function () {
            $(this).addClass('visited');
            $('.service-card').removeClass('last');
            $('.active').removeClass('active').addClass('last');
            $(this).addClass('active');
            $(this).siblings().addClass('active');
        });


        // $('').html(function(){
        //     const text= $(this).text().trim().split(" ");
        //     const first = text.shift();
        //     return (text.length > 0 ? "<span class='first'>"+ first + "</span> " : first) + text.join(" ");
        // });

        // Last word
        // -----------------------------------
        $('.service-card h3').html(function(){
            const text = $(this).text().split(' ');
            const last = text.pop();
            return text.join(" ") + (text.length > 0 ? ' <span class="last">'+last+'</span>' : last);
        });
    });
})(jQuery);
